module.exports = __webpack_public_path__ + "img/gatetopay.21e4d205.svg";